import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 md:px-6 md:pb-20">
      <div className="relative isolate overflow-hidden rounded-3xl bg-primary-500 px-6 py-14 text-center md:py-20">
        <div className="absolute inset-0 -z-10">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20abstract%20manga%20comic%20background%20of%20floating%20colorful%20speech%20bubbles%20and%20stars%20in%20warm%20orange%20and%20golden%20tones%2C%20soft%20playful%20illustration%2C%20clean%20composition%20with%20negative%20space%2C%20no%20text%2C%20energetic%20modern%20editorial%20style&width=1600&height=600&seq=cta-bg-comic&orientation=landscape"
            alt=""
            className="h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary-600/70"></div>
        </div>

        <div className="mx-auto max-w-2xl">
          <h2 className="font-heading text-3xl text-background-50 md:text-4xl">
            还在担心错过心爱的连载？
          </h2>
          <p className="mt-4 text-base text-primary-50 md:text-lg">
            现在就把正在追的漫画收进清单，开启更新提醒，让每一话都准时出现在你的追漫日历上。
          </p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
            <Link
              to="/comics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-bookmark-line"></i>
              开始收藏追更
            </Link>
            <Link
              to="/calendar"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-calendar-line"></i>
              查看追漫日历
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}